const scrollTo = (e, target) => {
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' })
  }
}

export default {
  install(Vue) {
    Vue.directive('scroll-to', {
      mounted: function (el, binding) {
        const target = document.querySelector(binding.value)

        el._clickScrollTo = e => scrollTo(e, target)
        el.addEventListener('click', el._clickScrollTo)
      },
      unmounted: function (el) {
        el.removeEventListener('click', el._clickScrollTo)
      }
    })
  }
}
